import * as React from "react";
import { Layout } from "./components/layout";
// import { Dashboard } from "./components/dashboard";
import Login from "./common/auth/Login";
import { AuthManager } from "./common/auth/Auth";
import { createBrowserHistory } from "history";
import themeReducer from "./common/redux/reducers/themeReducer";
import i18nProvider from "./common/i18n/i18nProvider";
import { persistenceRootSaga } from "./common/redux/sagas";
import { getCustomRoutes } from "./common/routes/customRoutes";
import { ApiManager } from "./common/data/ApiManager";
import {
  axiosReducer,
  initialAxiosState,
} from "./common/redux/reducers/axiosReducer";
import {
  appDataReducer,
  initialAppData,
} from "./common/redux/reducers/appDataReducer";
import { appDataSaga } from "./common/redux/sagas/appData";
import { createAdminStore } from "react-admin";
import { Provider } from "react-redux";
import { AdminWrapper } from "./common/admin-wrapper/AdminWrapper";
import {
  defaultHosDataReducer,
  initialDefaultHosData,
} from "./common/redux/reducers/defaultHosDataReducer";
import { defaultHosDataSagas } from "./common/redux/sagas/defaultHosDataSaga";
import "./App.css";
import {
  initialTenantState,
  tenantReducer,
} from "./common/redux/reducers/tenantReducer";
import { tenantQueryParamSaga } from "./common/redux/sagas/tenant";
import {
  fleetManagerHubReducer,
  initialFleetManagerHubState,
} from "./common/redux/reducers/fleetManagerHubReducer";
import {
  initialMaintenanceDashboardLayoutState,
  maintenanceDashboardLayoutReducer,
} from "./common/redux/reducers/maintenanceDashboardLayoutReducer";
import {
  initialVehicleMaintenanceDashboardLayoutState,
  vehicleMaintenanceDashboardLayoutReducer,
} from "./common/redux/reducers/vehicleMaintenanceDashboardLayoutReducer";
import { vehicleMaintenanceWidgetsConfigurationReducer } from "./common/redux/reducers/vehicleMaintenanceWidgetsConfigurationReducer";
import {
  initialMaintenanceDashboardLayoutLoadingState,
  maintenanceDashboardLoadingStateReducer,
} from "./common/redux/reducers/maintenanceDashboardLoadingStateReducer";

const history = createBrowserHistory<{}>();
const authProvider = new AuthManager(history);
const dataProvider = new ApiManager(
  authProvider,
  process.env["REACT_APP_API_URL"]?.replace(/\/+$/, "") ??
    "https://localhost:44327"
);

const App = () => {
  const LoginPage = (props: any) => (
    <Login authProvider={authProvider} {...props} />
  );

  const customRoutes = getCustomRoutes(authProvider);
  const customSagas = [
    persistenceRootSaga,
    appDataSaga,
    defaultHosDataSagas,
    tenantQueryParamSaga,
    // maintenanceDashboardSagas,
  ];

  const initialState = {
    axios: initialAxiosState,
    appData: initialAppData,
    defaultHosData: initialDefaultHosData,
    tenant: initialTenantState,
    fleetManagerHub: initialFleetManagerHubState,
    maintenanceDashboardLayout: initialMaintenanceDashboardLayoutState,
    vehicleMaintenanceDashboardLayout: initialVehicleMaintenanceDashboardLayoutState,
    maintenanceDashboardLayoutLoadingState: initialMaintenanceDashboardLayoutLoadingState,
  };

  return (
    <Provider
      store={createAdminStore({
        authProvider,
        dataProvider,
        history,
        customReducers: {
          theme: themeReducer,
          axios: axiosReducer,
          appData: appDataReducer,
          defaultHosData: defaultHosDataReducer,
          tenant: tenantReducer,
          fleetManagerHub: fleetManagerHubReducer,
          maintenanceDashboardLayout: maintenanceDashboardLayoutReducer,
          vehicleMaintenanceDashboardLayout: vehicleMaintenanceDashboardLayoutReducer,
          vehicleMaintenanceWidgetsConfiguration: vehicleMaintenanceWidgetsConfigurationReducer,
          maintenanceDashboardLayoutLoadingState: maintenanceDashboardLoadingStateReducer,
        },
        customSagas,
        initialState,
      })}>
      <AdminWrapper
        history={history}
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        loginPage={LoginPage}
        layout={Layout}
        // dashboard={Dashboard}
        customRoutes={customRoutes}
      />
    </Provider>
  );
};

export default App;
